//Home.js
import Navbar from "../components/MainNavbar";
import { useState, useEffect } from "react";
import parse from "html-react-parser";
import { TSongSheet } from "../types/SongSheet";
import { NavLink, useParams } from "react-router-dom";
import SongsNavbar from "../components/SongsNavBar";
import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";
import { AutoScrollButton } from "../components/AutoScroll";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMicrophoneLines,
  faMinus,
  faPenToSquare,
  faPlus,
  faPrint,
  faTag,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import { DeleteSongSheetById, GetSongSheetById } from "../services/SongSheet";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Tag } from "react-tag-input/types/components/SingleTag";

const SongSheet = () => {
  const [data, setData] = useState<TSongSheet>();
  const [model, setModel] = useState(data?.lyrics);
  const [fontSize, setFonSize] = useState(16);
  const navigate = useNavigate();

  const deleteSongSheet = (event: any, songId: string | undefined) => {
    event.preventDefault();

    if (songId) {
      console.log(`Delete song ${songId}`);
      DeleteSongSheetById(
        songId,
        (res: any) => {
          console.log(res);
          toast.success("Song Sheet was deleted!");
          navigate("/songs");
        },
        (err: any) => {
          console.log(err);
          toast.error("An error occured deleting the song sheet");
        }
      );
    }
  };

  const FontSizeButtons = () => {
    return (
      <div>
        <button
          type="button"
          className="btn btn1"
          onClick={() => setFonSize(fontSize - 2)}
        >
          <FontAwesomeIcon icon={faMinus} />
        </button>
        <button
          type="button"
          className="btn btn1"
          onClick={() => setFonSize(fontSize + 2)}
        >
          <FontAwesomeIcon icon={faPlus} />
        </button>
        {fontSize}
      </div>
    );
  };

  const handleModelChange = (event: any) => {
    setModel(event);
  };
  let { id } = useParams();

  console.log(id);

  const renderLyrics = () => {
    return (
      <div className="lyricsContainer" style={{ fontSize: fontSize }}>
        {parse(data?.lyrics || "")}
      </div>
    );
  };

  useEffect(() => {
    renderLyrics();
  }, [fontSize]);

  useEffect(() => {
    if (id) {
      GetSongSheetById(
        id,
        (res: any) => {
          //success
          setData(res.data.songSheet);
          setFonSize(res.data.songSheet.defaultFontSize);
        },
        (err: any) => {
          //error
          alert(err);
        }
      );
    }
  }, []);

  return (
    <div>
      <Navbar />
      <SongsNavbar />

      <ul className="horizontal">
        <li>
          <NavLink to={`/songs/edit/${id}`}>
            <FontAwesomeIcon icon={faPenToSquare} /> Edit
          </NavLink>
        </li>

        <li>
          <a type="simpleQuery" onClick={(e) => deleteSongSheet(e, id)}>
            <FontAwesomeIcon icon={faTrashCan} /> Delete
          </a>
        </li>

        <li>
          <a className="btn" href="#">
            <FontAwesomeIcon icon={faPrint} /> Print
          </a>
        </li>
        <li>
          <AutoScrollButton />
        </li>
        <li>
          <FontSizeButtons />
        </li>
      </ul>

      <div className="mainContainer">
        <h1>{`${data?.artist} - ${data?.name}`}</h1>
        <h3>{data?.songType}</h3>

        <div>
          <strong>Capo: {data?.capo}</strong>

          <FroalaEditorView model={data?.chords} />
        </div>

        {renderLyrics()}

        <div>
          <ul className="tagList">
            {data?.tags?.map((tag: Tag) => (
              <li>
                <div className="chip">
                  <NavLink to="/songs">
                    {" "}
                    <span className="tagIcon">
                      <FontAwesomeIcon icon={faTag} />
                    </span>{" "}
                    {tag.id}
                  </NavLink>
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div></div>

        <div>
          <FroalaEditorView model={model} />
        </div>

        {/* {data.map(item => (
          <div>
            <p key={item.name}>{item.name}</p>
            <hr />
              {parse(item.lyrics)}
            </div>  
          ))} */}
      </div>
    </div>
  );
};

export default SongSheet;
